import {Component, OnInit} from '@angular/core';
// removed legacy rxjs-compat operator import
import {Router} from '@angular/router';
import {UserVerificationService} from "../services/user-verification.service";
import { Subscription } from 'rxjs';
import {ApiEndpoints} from "../services/api-endpoints";
import {KeycloakService} from "../services/keycloak.service";

declare var $: any;

@Component({
  standalone: false,
  selector: 'app-header',
  templateUrl: './header.component.html',
})
export class HeaderComponent implements OnInit {

  isAdmin: boolean = false;
  filterSearch: any;
  keywordSearch: any;
  logOutToggle: boolean = true;
  serverUrl: any;

  isAdminSubscription: Subscription;

  reDirect(serverUrl, filterSearch, keywordSearch) {
    if (filterSearch != "Search Type") {
      if (serverUrl == ApiEndpoints.GET_ALL_NETWORK_SERVERS) {
        this.router.navigate(['/all-network', filterSearch, keywordSearch]);
      }
      if (serverUrl == ApiEndpoints.GET_ALL_JOIN_SERVERS) {
        this.router.navigate(['/all-join', filterSearch, keywordSearch]);
      }
      // if(serverUrl=="./getAllUsers"){
      //   this.router.navigate(['/admin-users',filterSearch,keywordSearch]);
      // }
    }
  }

  constructor(private router: Router,
              private userVerificationService: UserVerificationService,
              private keycloakService: KeycloakService) {
    this.isAdmin = this.userVerificationService.isAdmin;
  }

  logout() {
    this.keycloakService.logout();
  }

  verifyAdmin() {
    this.logOutToggle = !this.logOutToggle
    this.userVerificationService.message.next(this.logOutToggle)
  }

  search(filterSearch, keywordSearch, serverUrl) {
    if (serverUrl == "netId") {
      serverUrl = ApiEndpoints.GET_ALL_NETWORK_SERVERS;
    }
    if (serverUrl == "joinEui") {
      serverUrl = ApiEndpoints.GET_ALL_JOIN_SERVERS;
    }
    // if(serverUrl=="users"){
    //   serverUrl = "./getAllUsers";
    // }
    if (filterSearch == "NetID") {
      filterSearch = "netId";
    }
    if (filterSearch == "NSID") {
      filterSearch = "nsId";
    }
    if (filterSearch == "Name") {
      filterSearch = "name";
    }
    if (filterSearch == "JoinEUI") {
      filterSearch = "joinEui";
    }
    // if(filterSearch=="Username") {
    //   filterSearch = "username";
    // }
    // if(filterSearch=="Affiliation") {
    //   filterSearch = "affiliation";
    this.reDirect(serverUrl, filterSearch, keywordSearch);
  }

  ngOnInit() {

    // open close left menu
    $('[data-toggle="offcanvas"]').click(function () {
      $('.row-offcanvas').toggleClass('active')
    });

    var self = this;
    let timeoutRef;
    const ONE_SEC = 1000;
    $("nav .form-inline .form-control").keyup(function (e) {
      if (typeof timeoutRef !== "undefined") {
        clearTimeout(timeoutRef)
      }
      var filterSearch = $("nav .header-search :selected").text();
      var keywordSearch = $(this).val();
      var serverUrl = $("nav .header-search :selected").val();
      if (e.which == 13) {
        self.search(filterSearch, keywordSearch, serverUrl);
      }
    });
    $("#i-search-text").click(function(e) {
      var filterSearch = $("nav .header-search :selected").text();
      var keywordSearch = $("#header-search-text").val();
      var serverUrl = $("nav .header-search :selected").val();
      self.search(filterSearch, keywordSearch, serverUrl);
    });
  }

  searchClicked() {
    var filterSearch = $("nav .header-search :selected").text();
    var keywordSearch = $(this).val();
    var serverUrl = $("nav .header-search :selected").val();
    this.search(filterSearch, keywordSearch, serverUrl);
  }

  ngOnDestroy() {
  }

}
